<template>
  <div class="bg-gray">
    <navigation-bar :mode="'Admin'"></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <h1>{{store.state.service.name }}</h1>
                <hr>
                <h2>Fields</h2>
                <div class="row" v-if="clickedField">
                  <div class="col-sm-12">
                    <div class="alert alert-danger" role="alert">
                        Are you sure you want to disable {{clickedField.name}}?
                        <br><br>
                        <button @click="seriouslyDisable" class="btn btn-danger btn-orange">Disable It!</button>
                        <button @click="cancelDisable" class="btn btn-default btn-blue">Cancel</button>
                      </div>
                  </div> 
                </div>
                <!-- Content -->
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Active</th>
                      <th class="hidden-sm" scope="col">Required</th>
                      <th scope="col">Type</th>
                      <th class="hidden-sm" scope="col">Searchable</th>
                      <th scope="col">Character Limit</th>
                      <Th class="hidden-sm" scope="col">Show In Table</Th>
                      <th class="hidden-sm" scope="col">Show In Table On Small</th>
                      <th class="hidden-sm" scope="col">Select Options</th>
                      <th scope="col">Disable</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="field in store.state.fields" :key="field.id">
                      <td>{{field.name}}</td>
                      <td>{{field.active == 1 ? 'Yes' : 'No'}}</td>
                      <td class="hidden-sm">{{field.required == 1 ? 'Yes' : 'No' }}</td>
                      <td>{{field.type}}</td>
                      <td class="hidden-sm">{{field.searchable == 1 ? 'Yes' : 'No' }}</td>
                      <td>{{field.characterLimit}}</td>
                      <td class="hidden-sm">{{field.showInTable == 1 ? 'Yes' : 'No'}}</td>
                      <td class="hidden-sm">{{field.showInTableOnSmall == 1 ? 'Yes' : 'No'}}</td>
                      <td class="hidden-sm">{{field.selectOptions}}</td>
                      <td>
                        <button v-if="field.active == 1" @click="disable(field)" style="color:white;" class="btn btn-danger btn-orange">Disable</button>
                        <span v-else>Disabled</span>
                        </td>
                    </tr>
                  </tbody>
                </table>
                <br><hr>
                <h2>Add a Field</h2>
                <div class="row" v-if="store.state.form">
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Service Name</label>
                      <input v-model="store.state.form.name" class="form-control" placeholder="Name"/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Required</label>
                      <select class="form-control" v-model="store.state.form.required">
                        <option value="">--Select an Option--</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Type</label>
                      <select class="form-control" v-model="store.state.form.type">
                        <option value="">--Select an Option--</option>
                        <option v-for="type in store.state.types" :key="type" :value="type">{{type}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Searchable</label>
                      <select class="form-control" v-model="store.state.form.searchable">
                        <option value="">--Select an Option--</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6" v-if="requireCharacterLimit">
                    <div class="form-group">
                      <label>Character Limit</label>
                      <input type="number" v-model="store.state.form.characterLimit" class="form-control" placeholder="Character Limit"/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Show In Table</label>
                      <select class="form-control" v-model="store.state.form.showInTable">
                        <option value="">--Select an Option--</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Show In Table On Small Screen</label>
                      <select class="form-control" v-model="store.state.form.showInTableOnSmall">
                        <option value="">--Select an Option--</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12" v-if="selectable">
                    <div class="form-group">
                      <label>Select Options</label><br>
                      <small>Comma separated list of options for select dropdown</small>
                      <input v-model="store.state.form.selectOptions" class="form-control" placeholder="Select Options"/>
                    </div>
                  </div>
                  
                  <div class="col-sm-12 text-center" style="margin-top:20px;">
                    <button @click="createField" style="width:200px;" class="btn btn-primary btn-blue">Save</button>
                  </div>
                </div>
              </div>
            </div>
            <br>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar.vue'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AdminServiceFieldsStore from './AdminServiceFieldsStore'
import AdminPermissionsUtils from './AdminPermissionsUtils'

export default {
  name: 'AdminServiceFields',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: AdminServiceFieldsStore,
      adminUtils: AdminPermissionsUtils,
      clickedField: null
    }
  },
  mounted () {

    this.store.state.types.sort();

    this.adminUtils.authorize((userId) => {
      
      this.store.state.currentUserId = userId;
      this.getService();
    },(err) => {
      
      this.$toasted.show(err, { type: 'error', duration: 2500 })
    })
  },
  computed:{
    requireCharacterLimit(){
      return this.store.state.form.type == 'Text' || field.type == 'Text Area' || this.store.state.form.type == 'Website' || this.store.state.form.type == 'Email'
    },
    selectable(){
      return this.store.state.form.type == 'Select Dropdown' || this.store.state.form.type == 'Multi Select Dropdown'
    }
  },
  methods: {
    createField: function () {
      this.store.createServiceField((data)=>{
        
        this.getService()
        this.store.resetForm()
      },(err)=>{
        
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    },
    getService: function() {
      this.store.state.serviceId = this.$route.params.serviceId
      
      this.store.getService((data) => {
        
      }, (err) => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    },
    disable: function(field) {
      this.clickedField = field
    },
    seriouslyDisable: function() {
      this.store.state.disableFieldId = this.clickedField.id
      this.store.disableServiceField(data => {
        this.clickedField = null;
        this.store.getService((data) => {
        
      }, (err) => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
      }, err => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    },
    cancelDisable: function() {
      this.clickedField = null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminServiceFields.vue